// @noflow

const BracketMapping = {
  // Round 2
  33: [1, 2],
  34: [3, 4],
  35: [5, 6],
  36: [7, 8],
  37: [9, 10],
  38: [11, 12],
  39: [13, 14],
  40: [15, 16],
  41: [17, 18],
  42: [19, 20],
  43: [21, 22],
  44: [23, 24],
  45: [25, 26],
  46: [27, 28],
  47: [29, 30],
  48: [31, 32],
  // Round 3
  49: [33, 34],
  50: [35, 36],
  51: [37, 38],
  52: [39, 40],
  53: [41, 42],
  54: [43, 44],
  55: [45, 46],
  56: [47, 48],
  // Round 4
  57: [49, 50],
  58: [51, 52],
  59: [53, 54],
  60: [55, 56],
  // Round 5
  61: [57, 58],
  62: [59, 60],
  // Round 6
  63: [61, 62],
};

export default BracketMapping;
